var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField } from '@material-ui/core';
import { TranslatableControl } from "../TranslatableControl";
export const TranslatableTextField = (_a) => {
    var { localTranslation = false, name, control, style = {}, defaultValue, rules, shouldUnregister } = _a, props = __rest(_a, ["localTranslation", "name", "control", "style", "defaultValue", "rules", "shouldUnregister"]);
    return React.createElement(TranslatableControl, { render: ({ field }) => (React.createElement(TextField, Object.assign({}, props, field))), name: name, control: control, style: style, localTranslation: localTranslation, defaultValue: defaultValue, rules: rules, shouldUnregister: shouldUnregister });
};
//# sourceMappingURL=index.js.map